import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '@app/services';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
    
    constructor (
        private router: Router,
        private authService: AuthService
    ) {}
    
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {              
            return this.checkTokenLogin();
    }
        
    async checkTokenLogin() {  
        let check = await this.authService.checkTokenLogin(false); 
        if(check){
            return this.router.parseUrl('home');
        }       
        return true;        
    }
}
